import React from "react";
import CompareModalTableHeader from "properties/compare/modal/compare-modal-table-header";
import { ItemMapper } from "maps/ItemMapper";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { CompareProps } from "properties/propertyCard/components/favorite/compare-provider";
import { unitsStore } from "units/_stores/unitsStore";

export const CompareModalTableUnitHeader = ({ item }: { item: CompareProps }) => {
    const unit = unitsStore.getSync(item.itemId);
    return <CompareModalTableHeader item={ItemMapper.toCompare(unit, COMMON_RESOURCE.UNIT)} />;
};
